import React from 'react';
import styled from 'styled-components';
import Rule from './Rule';
import { useIntl } from 'react-intl';
import { getTranslatedText } from '@nile/components';

const RuleGroup = ({
  id,
  parentId,
  combinator,
  rules,
  translations,
  schema,
  not,
  errors
}) => {
  const {
    classNames,
    combinators,
    controls,
    createRule,
    createRuleGroup,
    getLevel,
    isRuleGroup,
    onGroupAdd,
    onGroupRemove,
    onPropChange,
    onRuleAdd,
    showCombinatorsBetweenRules,
    showNotToggle,
    fetchValues,
    dependentFields
  } = schema;

  const hasParentGroup = () => !!parentId;
  const intl = useIntl();

  const onCombinatorChange = (value) => {
    console.log(value);
    onPropChange('combinator', value, id);
  };

  const onNotToggleChange = (checked) => {
    onPropChange('not', checked, id);
  };

  const addRule = (event) => {
    event.preventDefault();
    event.stopPropagation();

    const newRule = createRule();
    onRuleAdd(newRule, id);
  };

  const addGroup = (event) => {
    event.preventDefault();
    event.stopPropagation();

    const newGroup = createRuleGroup();
    onGroupAdd(newGroup, id);
  };

  const removeGroup = (event) => {
    event.preventDefault();
    event.stopPropagation();

    onGroupRemove(id, parentId);
  };

  const level = getLevel(id);

  return (
    <RuleGroupWrapper
      className={`ruleGroup ${classNames.ruleGroup}`}
      data-rule-group-id={id}
      data-level={level}
      data-qa="ruleGroup"
    >
      <div className={`ruleGroup-header ${classNames.header}`}>
        {/* {showCombinatorsBetweenRules ? null : ( */}
        {level === 0 && (
          <div id="rule.combinator">
            <controls.combinatorSelector
              options={combinators}
              value={combinator}
              title={translations.combinators.title}
              className={`ruleGroup-combinators ${classNames.combinators}`}
              handleOnChange={onCombinatorChange}
              rules={rules}
              level={level}
              dependentFields={dependentFields}
            />
          </div>
        )}
        {/* )} */}
        {!showNotToggle ? null : (
          <controls.notToggle
            className={`ruleGroup-notToggle ${classNames.notToggle}`}
            title={translations.notToggle.title}
            checked={not}
            handleOnChange={onNotToggleChange}
          />
        )}
        {/* {hasParentGroup() ? (
          <controls.removeGroupAction
            label={translations.removeGroup.label}
            title={translations.removeGroup.title}
            action={translations.removeGroup.action}
            className={`ruleGroup-remove ${classNames.removeGroup}`}
            handleOnClick={removeGroup}
            rules={rules}
            level={level}
          />
        ) : null} */}
      </div>
      {rules.map((r, idx) => (
        <RuleGroupItem className="vignesh" key={r.id}>
          {idx && showCombinatorsBetweenRules ? (
            // <controls.combinatorSelector
            //   options={combinators}
            //   value={combinator}
            //   title={translations.combinators.title}
            //   className={`ruleGroup-combinators betweenRules ${classNames.combinators}`}
            //   handleOnChange={onCombinatorChange}
            //   rules={rules}
            //   level={level}
            // />
            level === 0 ? (
              <CombinatorTag value={combinator} className="flex">
                <Combinator value={combinator}>{combinator}</Combinator>
                <div className="triangle-right"></div>
              </CombinatorTag>
            ) : (
              <controls.combinatorSelector
                options={combinators}
                value={combinator}
                title={translations.combinators.title}
                className={`ruleGroup-combinators ${classNames.combinators}`}
                handleOnChange={onCombinatorChange}
                rules={rules}
                level={level}
                type="classic"
                dependentFields={dependentFields}
              />
            )
          ) : null}
          {isRuleGroup(r) ? (
            <RuleGroup
              id={r.id}
              schema={schema}
              parentId={id}
              combinator={r.combinator}
              translations={translations}
              rules={r.rules}
              not={r.not}
              errors={errors?.[0]?.errors?.[idx]?.error?.operands}
            />
          ) : (
            <Rule
              id={r.id}
              field={r.field}
              value={r.value}
              operator={r.operator}
              operatorValue={r.operatorValue}
              schema={schema}
              parentId={id}
              groupParentId={parentId}
              translations={translations}
              rules={rules}
              index={idx}
              errors={errors}
            />
          )}
        </RuleGroupItem>
      ))}
      {/* <controls.addRuleAction
        label={translations.addRule.label}
        title={translations.addRule.title}
        action={translations.addRule.action}
        className={`ruleGroup-addRule ${classNames.addRule}`}
        handleOnClick={addRule}
        rules={rules}
        level={level}
      /> */}

      {level === 0 && (
        <div id="rule.add" className="add-rule">
          <controls.addGroupAction
            label={getTranslatedText(intl, translations.addGroup.label)}
            title={translations.addGroup.title}
            action={translations.addGroup.action}
            className={`ruleGroup-addGroup ${classNames.addGroup}`}
            handleOnClick={addGroup}
            rules={rules}
            level={level}
          />
        </div>
      )}
    </RuleGroupWrapper>
  );
};

const RuleGroupWrapper = styled.div`
  .add-rule {
    margin-top: 20px;
  }
`;

const RuleGroupItem = styled.div`
  .ruleGroup {
    border-radius: 5px;
    border: 1px solid #ebebeb !important;
    margin: 20px 0;
  }

  .rule {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .value_selector__control {
    border-bottom: 0 !important;
  }
`;

const Combinator = styled.div`
  text-transform: uppercase;
  color: #ffffff;
  font-weight: bold;
  padding: 0 8px;
  background: ${(props) => (props.value === 'OR' ? '#E65D0F' : '#6C69FF')};
  font-size: 12px;
  line-height: 18px;
`;

const CombinatorTag = styled.div`
  .triangle-right {
    border-left: 10px solid
      ${(props) => (props.value === 'OR' ? '#E65D0F' : '#6C69FF')};
  }
`;

RuleGroup.defaultProps = {
  id: null,
  parentId: null,
  rules: [],
  combinator: 'AND',
  schema: {}
};

RuleGroup.displayName = 'RuleGroup';

export default RuleGroup;
